import http from "../../services/http";
const path = "api/section";
const studentIvite = ({ onSuccess, onError, onEnd, joinCode = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: `${path}/joincode/${joinCode}`,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { studentIvite };
